import { Button, Flex, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Progress, Text, useDisclosure } from "@chakra-ui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import axios from "axios";
import dayjs from "dayjs";
import { useState } from "react";
import { AiFillEye } from "react-icons/ai";
import { Store } from 'react-notifications-component';



const ViewPropositionModal = (props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { address } = useGetAccountInfo();
    const [isLoadingYes, setisLoadingYes] = useState();
    const [isLoadingNo, setisLoadingNo] = useState();
    const isLoggedIn = Boolean(address);
    const isExpired = Boolean(new Date() > new Date(props.data.expiredAt));
    const quorum = '1000';

    const votesDataYes = {
        "userWalletAddress": address,
        "proposalId": props.data._id,
        "type": "yes"
    }
    const votesDataNo = {
        "userWalletAddress": address,
        "proposalId": props.data._id,
        "type": "no"
    }

    function getErdHidden(str) {
        return str
        .split(' ')
        .map(word => word[0] + word[1] + word[2] + word[3] + '...' + word[58] + word[59] + word[60] + word[61] )
        .join('');
    }

    function proposalVotesYes() {
        setisLoadingYes(true);
        axios.post(`${process.env.REACT_APP_API_URL}/votes`, votesDataYes, {
            headers: {
                signature: localStorage.getItem("signature")
            }
        })
        .then(() => {
            Store.addNotification({
                title: "Voted successfully 🚀",
                message: 'You just voted' + props.nbAstronauts + ' times YES for the proposition : ' +  props.data.title ,
                type: "success",
                insert: "top",
                container: "bottom-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    pauseOnHover: true
                }
            });
        })
        .catch(error => {
            Store.addNotification({
                title: "Votes not submitted",
                message: error.response.data.message,
                type: "danger",
                insert: "top",
                container: "bottom-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    pauseOnHover: true
                }
            });
        }).finally(() => {
            props.setisMutating(true);
            setisLoadingYes(false);
        })
    }

    function proposalVotesNo() {
        setisLoadingNo(true);
        axios.post(`${process.env.REACT_APP_API_URL}/votes`, votesDataNo, {
            headers: {
                signature: localStorage.getItem("signature")
            }
        })
        .then(() => {
            Store.addNotification({
                title: "Voted successfully 🚀",
                message: 'You just voted ' + props.nbAstronauts + ' times NO for the proposition : ' + props.data.title,
                type: "success",
                insert: "top",
                container: "bottom-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    pauseOnHover: true
                }
            });
        })
        .catch(error => {
            Store.addNotification({
                title: "Votes not submitted",
                message: error.response.data.message,
                type: "danger",
                insert: "top",
                container: "bottom-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    pauseOnHover: true
                }
            });
        }).finally(() => {
            props.setisMutating(true);
            setisLoadingNo(false);
        })
    }

    return (
        <>
            <Icon
                onClick={onOpen}
                w='24px'
                h='24px'
                me='5px'
                color={'white'}
                as={AiFillEye}
                cursor='pointer'
            />
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent bg={'navy.800'}>
                    <ModalHeader>{props.data.title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody mb={15}>
                        {/* <FormDao data={props.data} edit={false} /> */}
                        <Flex fontFamily={"body"} mb={25}>
                        {props.data.description}
                        </Flex>
                        <Flex align='center' justifyContent={'space-between'}>
                            Yes - {props.data.yesVotes}
                            <Progress
                                mr={5}
                                ml={5}
                                variant='table'
                                colorScheme='green'
                                h='8px'
                                w='108px'
                                value={(props.data.yesVotes / ((props.data.yesVotes + props.data.noVotes) || 1))*100}
                            />
                            {isLoggedIn && !isExpired && !!props.nbAstronauts && (
                                <>
                                    <Button isLoading={isLoadingYes} onClick={proposalVotesYes} className="btn-secondary" width={'100px'}>Vote Yes</Button>
                                </>
                            )}
                        </Flex>
                        <Flex mt={5} align='center' justifyContent={'space-between'} >
                            No - {props.data.noVotes}
                            <Progress
                                mr={5}
                                ml={5}
                                variant='table'
                                colorScheme='red'
                                h='8px'
                                w='108px'
                                value={(props.data.noVotes / ((props.data.yesVotes + props.data.noVotes) || 1))*100}
                            />
                            {isLoggedIn && !isExpired && !!props.nbAstronauts && (
                                <>
                                    <Button isLoading={isLoadingNo} onClick={proposalVotesNo} className="btn-secondary" width={'100px'}>Vote No</Button>
                                </>
                            )}
                        </Flex>
                        <Flex fontFamily={"body"} mt={25}>
                            <Text padding={'10px 15px'} background='blackAlpha.400' borderRadius={10} letterSpacing='0.8px'>
                            {'By : ' + getErdHidden(props.data.userWalletAddress)}
                            </Text>
                        </Flex>
                        <Flex fontFamily={"body"} mt={25}>
                            {'Quorum: ' + quorum}
                        </Flex>
                    <Flex fontFamily={"body"} mt={25}>
                            {(isExpired ? 'Votes closed on ' : 'Voting will expire on ') + dayjs(new Date(props.data.expiredAt)).format('DD MMM YYYY')}
                    </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default ViewPropositionModal;